export default {
  ONE: {
    START_EDITING: 'START_EDITING_ONE_BOOKMARK',
    STOP_EDITING: 'STOP_EDITING_ONE_BOOKMARK',
    CREATE: {
      REQUEST: 'REQUEST_CREATE_ONE_BOOKMARK',
      RECEIVE: 'RECEIVE_CREATE_ONE_BOOKMARK',
      FAIL: 'FAIL_CREATE_ONE_BOOKMARK'
    },
    EDIT: {
      REQUEST: 'REQUEST_EDIT_ONE_BOOKMARK',
      RECEIVE: 'RECEIVE_EDIT_ONE_BOOKMARK',
      FAIL: 'FAIL_EDIT_ONE_BOOKMARK'
    },
    DELETE: {
      REQUEST: 'REQUEST_DELETE_ONE_BOOKMARK',
      RECEIVE: 'RECEIVE_DELETE_ONE_BOOKMARK',
      FAIL: 'FAIL_DELETE_ONE_BOOKMARK'
    }
  },
  MULTI: {
    GET_ALL: {
      REQUEST: 'REQUEST_GET_ALL_BOOKMARKS',
      RECEIVE: 'RECEIVE_GET_ALL_BOOKMARKS',
      FAIL: 'FAIL_GET_ALL_BOOKMARKS'
    }
  }
}
